import React from "react";

function Privacy() {
  return (
    <div style={{ maxWidth: "800px", margin: "40px auto", padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Privacy Policy for Blickfast</h1>
      <p>Last Updated: April 22, 2025</p>
      
      <h2>1. Data Collection</h2>
      <p>We only collect what's needed to let you manage your TikTok content.</p>
      
      <h2>2. Data Usage</h2>
      <p>Your data is only used to provide the Blickfast service, image hosting and Tiktok content posting.</p>
      
      <h2>3. Third Parties</h2>
      <p>We don't sell your data to anyone.</p>
      
      <h2>4. TikTok Compliance</h2>
      <p>We follow all TikTok Platform Terms and Developer Policies.</p>
      
      <h2>5. Contact</h2>
      <p>Questions? Email us: <strong>founders@naturalui.com</strong></p>
    </div>
  );
}

export default Privacy; 